export const SET_SELECTED_MARKER ='SET_SELECTED_MARKER';
export const REMOVE_SELECTED_MARKER='REMOVE_SELECTED_MARKER';
